import {useLayoutEffect, useRef} from 'react'
import {useClientTool} from '@github-ui/ahp-client-tools'

import type {DebugEvent} from '../types'
import {
  AHP_DEBUG_LOG_TOOL_DEFINITION,
  createAhpDebugLogToolState,
  fulfilAhpDebugLogTool,
} from '@github-ui/agent-sessions/ahp/ahp-debug-log-tool'

export function useAhpDebugLogTool(debugEvents: readonly DebugEvent[], sessionKey: string | undefined): void {
  const stateRef = useRef(createAhpDebugLogToolState())

  useLayoutEffect(() => {
    stateRef.current = createAhpDebugLogToolState()
  }, [sessionKey])

  useClientTool(AHP_DEBUG_LOG_TOOL_DEFINITION, (params, call) =>
    fulfilAhpDebugLogTool(params, call, debugEvents, stateRef.current),
  )
}
